import api from "../../../../services/api";

export const searchDoctor = async (search: string, signal?: AbortSignal): Promise<{ doctors: { id: number; medico_nome: string }[], total: number }> => {
    try {
        return (await api.get('/doctor/filter', { params: { search }, signal })).data;
    } catch (e) {
        return { doctors: [], total: 0 };
    }
}